import React from 'react'
import socketIOClient from 'socket.io-client'

const socket = socketIOClient('/', {path: '/ws'})


export const SocketContext = React.createContext(false)

export const SocketProvider = ({ children }) => {

  return (
    <SocketContext.Provider
      value={{ socket }}
    >
      {children}
    </SocketContext.Provider>
  )
}
